import { useState } from "react";
import { supabase } from "@/utils/supabase/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";

export default function PasswordProtection({ spaceId, onPasswordVerified }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const { data, error } = await supabase.rpc("verify_space_password", {
        space_id: spaceId,
        password_attempt: password,
      });

      if (error) throw error;

      if (data.verified) {
        onPasswordVerified();
      } else {
        setError("Incorrect password");
      }
    } catch (err) {
      setError("Failed to verify password");
      console.error("Password verification error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-[50vh] flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-8 bg-dark-surface p-8 rounded-2xl">
        <div className="text-center space-y-4">
          <div className="mx-auto w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
            <FontAwesomeIcon icon={faLock} className="w-6 h-6 text-primary" />
          </div>
          <h2 className="text-2xl font-medium text-white">
            This space is password protected
          </h2>
          <p className="text-sm text-gray-400">
            Please enter the password to view this space
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="w-full bg-dark-elevated text-white placeholder-gray-500 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
            />
            {error && <p className="mt-2 text-sm text-red-500">{error}</p>}
          </div>

          <button
            type="submit"
            disabled={!password || isLoading}
            className="w-full bg-primary hover:bg-primary/90 text-white rounded-lg px-4 py-2 text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? "Verifying..." : "Continue"}
          </button>
        </form>
      </div>
    </div>
  );
}
